import React, { useState } from "react";
import { FileText, File as FileIcon } from "lucide-react";
import { PreviewDrawer } from "./GalleryPreview";

// Documents the assistant pulled from the Gallery: icon chips; click → preview in the right-hand drawer.
export function GalleryDocs({ docs = [] }) {
  const [open, setOpen] = useState(null);
  if (!docs.length) return null;
  return (
    <div className="mt-2 flex flex-wrap gap-1.5" data-testid="gallery-docs">
      {docs.map((d) => (
        <button key={d.id} type="button" onClick={() => setOpen(d)} data-testid="gallery-doc-chip" title={`Lihat ${d.name}`}
          className="flex max-w-full items-center gap-2 rounded-xl border border-[#E7ECF3] bg-white px-3 py-2 text-left text-xs font-semibold text-slate-700 transition hover:border-[#2F6BFF] hover:bg-[#EEF3FF]">
          <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-[#EEF3FF] text-[#2F6BFF]">{d.source === "upload" ? <FileIcon size={15} /> : <FileText size={15} />}</span>
          <span className="min-w-0"><span className="block truncate">{d.name}</span><span className="block text-[10px] font-normal text-slate-400">{(d.format || "dokumen").toUpperCase()}{d.persona_name ? ` · ${d.persona_name}` : ""}</span></span>
        </button>
      ))}
      {open && <PreviewDrawer item={open} onClose={() => setOpen(null)} />}
    </div>
  );
}
